import React from "react";
import { useModal } from "../../context/ModalContext";
import SettingsModal from "./SettingsModal";
import ProfileModal from "./ProfileModal";
import SecurityModal from "./SecurityModal";
import PaymentModal from "./PaymentModal";
import AddCardModal from "./AddCardModal";
import SimpleResultModal from "./SimpleResultModal";

function ModalRoot() {
  const { active, closeModal, replaceModal, openModal } = useModal();
  if (!active) return null;

  const commonClose = () => closeModal();

  switch (active.type) {
    case "settings":
      return <SettingsModal onClose={commonClose} source={active.props?.source} />;
    case "profile":
      return (
        <ProfileModal
          onClose={commonClose}
          onOpenSecurity={() => openModal("security")}
          onOpenSettings={() => openModal("settings", { source: "profile" })}
        />
      );
    case "security":
      return (
        <SecurityModal
          onClose={commonClose}
          onSuccess={() => openModal("success", { messageKey: "securityModal.updated" })}
        />
      );
    case "payment":
      return (
        <PaymentModal
          onClose={commonClose}
          onRequestAddCard={() => openModal("addCard")}
          onSuccess={() => openModal("success", { messageKey: "billing.pay.success" })}
          onError={(err) => {
            const key =
              err?.code === "NO_CARD"
                ? "billing.pay.errors.noCard"
                : err?.code === "INVALID_AMOUNT"
                  ? "billing.pay.errors.amount"
                  : "billing.pay.errors.failed";
            openModal("error", { messageKey: key });
          }}
        />
      );
    case "addCard":
      return (
        <AddCardModal
          onClose={commonClose}
          onSuccess={() => replaceModal("success", { messageKey: "billing.addCard.success" })}
        />
      );
    case "success":
      return (
        <SimpleResultModal
          variant="success"
          onClose={commonClose}
          messageKey={active.props?.messageKey || "common.success"}
          titleKey={active.props?.titleKey || "common.success"}
        />
      );
    case "error":
      return (
        <SimpleResultModal
          variant="error"
          onClose={commonClose}
          messageKey={active.props?.messageKey || "common.error"}
          titleKey={active.props?.titleKey || "common.error"}
        />
      );
    default:
      return null;
  }
}

export default ModalRoot;

